// Validation helpers for the admin pages (organisations & users)

export const isValidEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value).trim());

export const isValidDomain = (value) =>
  /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i.test(String(value).trim());

export const validateOrganisation = ({ name, domain, hsaId }, { requireDomain = false, requireHsaId = false } = {}) => {
  const errors = {};
  if (!name || !name.trim()) {
    errors.name = 'Organisationsnamn krävs.';
  } else if (name.trim().length < 2) {
    errors.name = 'Organisationsnamnet måste vara minst 2 tecken.';
  }
  if (requireDomain && (!domain || !domain.trim())) {
    errors.domain = 'Domän krävs.';
  } else if (domain && domain.trim() && !isValidDomain(domain)) {
    errors.domain = 'Ogiltig domän. Ange t.ex. exempel.se';
  }
  if (requireHsaId && (!hsaId || !hsaId.trim())) {
    errors.hsaId = 'HSA-ID krävs.';
  }
  return errors;
};

export const validateUser = ({ email }) => {
  const errors = {};
  if (!email || !email.trim()) {
    errors.email = 'E-post krävs.';
  } else if (!isValidEmail(email)) {
    errors.email = 'Ogiltig e-postadress. Ange t.ex. namn@exempel.se';
  }
  return errors;
};
